module.exports = __webpack_public_path__ + "img/stock0.52cd687d.png";